var map = {
	"./57_legs.mp3": "0ca9",
	"./58_hands.mp3": "941c",
	"./59_head.mp3": "2bbe",
	"./60_tummy.mp3": "eb83",
	"./61_stretch.mp3": "cdf6",
	"./62_shake.mp3": "dcc5",
	"./63_pat.mp3": "e8b5",
	"./64_hat.mp3": "2586",
	"./65_T-shirt.mp3": "2c6f",
	"./66_dress.mp3": "9877",
	"./67_jumper.mp3": "8c90",
	"./68_jacket.mp3": "6e9e",
	"./69_shoes.mp3": "e364",
	"./70_jeans.mp3": "60ea",
	"./M_Brilliant.mp3": "aef9",
	"./M_Excellent.mp3": "8eb6",
	"./M_Fantastic.mp3": "e746",
	"./M_Great.mp3": "e5f1",
	"./M_Perfect.mp3": "d67f",
	"./M_Think again.mp3": "61d2",
	"./M_Try again.mp3": "8404",
	"./M_Very good.mp3": "1e9c",
	"./M_Well done.mp3": "0629",
	"./M_Work harder.mp3": "58ae",
	"./click.mp3": "98f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ab6f";